// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
// v4 で変わった見た目を v3 に戻すためのスタイル
import '@/assets/sass/vuetify3-compat.scss'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify(
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  {
    display: {
      mobileBreakpoint: 'md',
    },
    theme: {
      // v4 のデフォルトは OS の設定に従う 'system'
      defaultTheme: 'light',
      themes: {
        light: {
          colors: {
            primary: '#6200EE',
            secondary: '#03DAC6',
          },
        },
      },
    },
    defaults: {
      global: {
        hideDetails: "auto",
      },
      VTable: {
        density: "compact",
      },
      VSelect: {
        variant: 'outlined',
        clearable: true,
        density: "compact",
      },
      VTextField: {
        variant: 'outlined',
        clearable: true,
        density: "compact",
      },
      VTextarea: {
        variant: 'outlined',
        clearable: true,
        density: "compact",
      },
      VCombobox: {
        variant: 'outlined',
        clearable: true,
        density: "compact",
      },
      VAutocomplete: {
        variant: 'outlined',
        prependInnerIcon: "mdi-magnify",
        clearable: true,
        density: "compact",
      },
      VFileInput: {
        variant: 'outlined',
        clearable: true,
        density: "compact",
      },
      VCheckbox: {
        density: "compact",
      },
    },
  }
)